import React from 'react';
import { getFileType } from '../../utilities/parsers';

const ConciliacionForm = ({
  fileToUpload,
  setFileToUpload,
  fileDescription,
  setFileDescription,
  fileType,
  setFileType,
  handleUpload,
  profile,
}) => {
    // FileType se refiere al tipo de archivo que se va a subir (Programado, Transmitido, Testigo que corresponde a 1,2 y 3 respectivamente), no al tipo de archivocomo tal aunque es calculado en el formulario, no es guardado en la bbdd
  setFileType(fileType)
  return (
        <section>
            <div className="columns mb-0 pb-0">
            <div className="column is-one-third">
                {!profile.is_admin && (
                <div className="field">
                    <div className="field-body">
                    <div className="field">
                        <div className="control is-expanded">
                        <label htmlFor="">Adjuntar Archivo</label>
                        <div className="file has-name is-dark">
                            <label className="file-label">
                            <input
                                className="file-input"
                                type="file"
                                name="resume"
                                onChange={(e) => {
                                    e.preventDefault();
                                    setFileToUpload(e.target.files)
                                    } 
                                }
                            />
                            <span className="file-cta">
                                <span className="file-icon">
                                <i className="fas fa-upload"></i>
                                </span>
                                <span className="file-label">
                                {fileToUpload.length > 0
                                    ? fileToUpload[0]?.name
                                    : 'Seleccionar Archivo'}
                                </span>
                            </span>
                            </label>
                        </div>
                        </div>
                    </div>
                    <div className="field">
                        <p className="control is-expanded">
                        <label htmlFor="">Tipo de Archivo</label>
                        <input
                            className="input"
                            type="text"
                            placeholder=""
                            disabled={true}
                            value={getFileType(fileToUpload[0]?.name)}
                        />
                        </p>
                    </div>
                    </div>
                </div>
                )}
            </div>
            <div className="column is-half">
                <div className="field">
                <p className="control is-expanded">
                    <label htmlFor="">Descripcion</label>
                    <input
                    autoFocus
                    className="input"
                    type="text"
                    placeholder="Descripción"
                    disabled={fileToUpload < 1}
                    value={fileDescription}
                    onChange={(e) => {
                        setFileDescription(e.target.value);
                    }}
                    />
                </p>
                </div>
            </div>
            {!profile.is_admin && (
                <div className="column is-one-fourth">
                <div className="field">
                    <label htmlFor="">&nbsp;</label>
                    <p className="control is-expanded">
                    <button
                        className="button is-dark"
                        disabled={!fileToUpload || fileToUpload.length === 0}
                        onClick={() => handleUpload(fileToUpload, fileDescription, fileType, profile)}
                    >
                        Subir Archivo
                    </button>
                    </p>
                </div>
                </div>
            )}
            </div>
        </section>
  );
};

export default ConciliacionForm;
